export const titleAlert = {
    'confirm_submit_1': 'Confirm Submit?',
    'confirm_submit_2': 'Confirm Submit?',
    'confirm_submit_3': 'Confirm Submit?',
};
